import { Loading } from 'element-ui';

let loading;

const startLoading = () => {
	loading = Loading.service({
		lock: true,
		text: '加载中……',
		background: 'rgba(255,255,255,0)'
	});
};

const endLoading = () => {
	loading.close();
};
export const showLoading = () => {
	startLoading();
	setTimeout(() => {
		loading.close();
	}, 1000)
};

export const hideLoading = () => {
	endLoading();
};
